import type { CapabilityRegistry } from '@trimble/web3d';
import { isMarkerEligiblePane } from '@mobile-mapping/web3d';
import {
  IssueMarkerIconCoordinator,
  IssueMarkerPickCoordinator,
} from '@trimble/tc-issue-management-web3d-utilities';

export function registerIssueMarkerCoordinators(
  capabilityRegistry: CapabilityRegistry
): void {
  capabilityRegistry.register(
    IssueMarkerIconCoordinator,
    new IssueMarkerIconCoordinator(capabilityRegistry, {
      isPaneEligible: isMarkerEligiblePane,
    })
  );

  capabilityRegistry.register(
    IssueMarkerPickCoordinator,
    new IssueMarkerPickCoordinator(capabilityRegistry, {
      isPaneEligible: isMarkerEligiblePane,
    })
  );
}
